import clsx from 'clsx';
import { SUITE_SEVERITY_META, type SuiteSeverity } from '../lib/suite-severity';

/**
 * The suite's status chip, after ton.org's stat chips: 32px pill on the
 * control fill, a band-coloured dot, the label, then the window's uptime as
 * the muted value (hidden below 640px, where the row title needs the room).
 */
export function StatusPill({
  severity,
  label,
  value,
}: {
  severity: SuiteSeverity;
  label?: string;
  /** Uptime over the selected window, e.g. `99.98%`. */
  value?: string;
}) {
  const meta = SUITE_SEVERITY_META[severity];
  return (
    <span
      className={clsx(
        'inline-flex h-8 items-center gap-2 whitespace-nowrap rounded-full px-3',
        'text-[14px] font-medium leading-4 tabular-nums',
        meta.pill,
      )}
    >
      <span
        aria-hidden
        className={clsx(
          'inline-block h-2 w-2 flex-shrink-0 rounded-full',
          meta.dot,
        )}
      />
      {label ?? meta.label}
      {value !== undefined && (
        <span className="hidden text-ink-3 sm:inline">{value}</span>
      )}
    </span>
  );
}
